'use strict';
import { computed, observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import moment from 'moment';
import { getEchartsArr } from '../../lib/lib';

/**
 * @param { moment.Moment | string } start
 * @param { moment.Moment | string } end
 * @returns {[ string, string ]}
 */
const formatStartEnd = (start, end) => {
  return [moment(start).startOf('day'), moment(end).endOf('day')].map(i =>
    i.format('YYYYMMDDHH')
  );
};

class DeviceInfoMonitorStore {
  @observable deviceNet = { title: '', xData: [], yData: [], color: [] };
  @observable deviceTraffic = { title: '', xData: [], yData: [], color: [] };
  @observable deviceMemory = { title: '', xData: [], yData: [], color: [] };
  @observable deviceCpu = { title: '', xData: [], yData: [], color: [] };
  @observable deviceProgress = [];

  @action
  loadCpu(deviceId, from, to) {
    const [start, end] = formatStartEnd(from, to);
    const urlPara = buildUrl({
      device_id: deviceId,
      start,
      end
    });
    fetch(`/api/device/cpu_usage${urlPara}`, { method: 'GET' }, json => {
      this.deviceCpu = getEchartsArr({
        title: 'CPU使用率',
        data: [...json],
        xDataName: 'time',
        information: [{ name: 'CPU使用率(%)', dataName: 'count' }],
        color: ['#ffd100']
      });
    });
  }
  @action
  loadMemory(deviceId, from, to) {
    const [start, end] = formatStartEnd(from, to);
    const urlPara = buildUrl({
      device_id: deviceId,
      start,
      end
    });
    fetch(`/api/device/memory_usage${urlPara}`, { method: 'GET' }, json => {
      this.deviceMemory = getEchartsArr({
        title: '内存使用率',
        data: [...json],
        xDataName: 'time',
        information: [{ name: '内存使用率(%)', dataName: 'count' }],
        color: ['#ffd100']
      });
    });
  }
  @action
  loadTraffic(deviceId, from, to) {
    const [start, end] = formatStartEnd(from, to);
    const urlPara = buildUrl({
      device_id: deviceId,
      start,
      end
    });
    fetch(`/api/device/data_traffic${urlPara}`, { method: 'GET' }, json => {
      this.deviceTraffic = getEchartsArr({
        title: '移动网络流量',
        data: [...json].map(item => {
          item.count = (item.count / 1024).toFixed(2);
          return item;
        }),
        xDataName: 'time',
        information: [{ name: '移动网络流量(MB)', dataName: 'count' }],
        color: ['#ffd100']
      });
    });
  }
  @action
  loadNet(deviceId, from, to) {
    const [start, end] = formatStartEnd(from, to);
    const urlPara = buildUrl({
      device_id: deviceId,
      start,
      end
    });
    fetch(`/api/device/network_traffic${urlPara}`, { method: 'GET' }, json => {
      this.deviceNet = getEchartsArr({
        title: '宽带/WIFI网络流量',
        data: [...json].map(item => {
          item.count = (item.count / 1024).toFixed(2);
          return item;
        }),
        xDataName: 'time',
        information: [{ name: '宽带/WIFI网络流量(MB)', dataName: 'count' }],
        color: ['#ffd100']
      });
    });
  }
  @action
  loadProgress(deviceId) {
    let urlPara = buildUrl({ device_id: deviceId });
    fetch(`/api/app/status${urlPara}`, { method: 'GET' }, json => {
      this.deviceProgress = [...json].map(item => {
        item['storage_usage'] =
          (item['storage_used'] / item['storage_total'] * 100).toFixed(2) ||
          '--';
        item['cpu_usage'] = (item['cpu_usage'] * 100).toFixed(2) || '--';
        item['memory_usage'] = (item['memory_usage'] * 100).toFixed(2) || '--';
        item['network_traffic'] =
          (item['network_traffic'] / 1024).toFixed(2) || '--';
        item['data_traffic'] = (item['data_traffic'] / 1024).toFixed(2) || '--';
        return item;
      });
    });
  }
}
export default new DeviceInfoMonitorStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/DeviceMonitor.js